module.exports = __webpack_public_path__ + "static/media/cave.a0e8799d.svg";